import useTranslation from 'next-translate/useTranslation';
import { Button } from '@arkestro/arkestro-design-system';
import styles from './lot-page-error.module.scss';
import type { ID } from 'types';

interface LotPageErrorProps {
  isRetrying?: boolean;
  lotId: ID;
  onRetry: () => void;
}

export const LotPageError = ({ isRetrying = false, lotId, onRetry }: LotPageErrorProps) => {
  const { t } = useTranslation('common');

  return (
    <div className={styles.pageError} data-testid={`${lotId}-line-items-page-error`} role='alert'>
      <span>{t('bid_request.line_items.pagination.page_error')}</span>
      <Button loading={isRetrying} onClick={onRetry} type='link'>{t('bid_request.line_items.pagination.retry')}</Button>
    </div>
  );
};
